<script>
    import { onMount } from "svelte";
    import { withResolvers } from "@otto-ec/assets-core-utils/promise";
    import Cinema from "../components/Cinema.svelte";
    import { getAggregationFeatureLabels, getFeatureOrder, getNextPiTrackingLabels } from "../utils/externalTrackingHelper.js";

    let { data } = $props();
    const {
        dreson: contentDresonRule,
        headline,
        recommendations,
        tracking,
        additionalClickTracking,
        metaData,
        featuresState,
        backgroundColor,
        hasPersonalisedRecommendations = false,
    } = data;

    let index = $state("0");
    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");
    let additionalTrackingLabels = $state(null);
    let cinemaContainer;
    let additionalNextPiTrackingLabels = $state(null);
    const [cinemaContainerMounted, mountSuccess] = withResolvers();
    const isSaleBlock = $derived(backgroundColor !== "white");

    onMount(() => {
        featureIndex = getFeatureOrder(cinemaContainer);
        additionalTrackingLabels = getAggregationFeatureLabels(cinemaContainer);
        additionalNextPiTrackingLabels = getNextPiTrackingLabels(cinemaContainer);
        cinemaInjectionContainerWidth = parseInt(cinemaContainer?.offsetWidth) || 1000;
        mountSuccess();
    });
</script>

<div bind:this={cinemaContainer}>
    <div class="reco_entry_page_cinema_wrapper" style:background-color={backgroundColor}>
        <Cinema
            {headline}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {featuresState}
            {cinemaInjectionContainerWidth}
            cinemaIndex={index}
            cinemaMeta={metaData}
            {additionalNextPiTrackingLabels}
            {additionalTrackingLabels}
            site="reco_entryPage"
            {contentDresonRule}
            personalisedUser={hasPersonalisedRecommendations}
            {cinemaContainerMounted}
            {isSaleBlock}
        />
    </div>
</div>

<style lang="scss">
    .reco_entry_page_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;
    }
</style>
